import React from 'react';
import MainHeader from '../components/MainHeader'; // adjust import path

const Layout = ({ children }) => {
  return (
    <>
      <MainHeader />
      <main>{children}</main>
    </>
  );
};

export default Layout;
